import React from 'react';
import clsx from 'clsx';
import capitalize from "../../helpers/capitalize";
import ValidationBlock from "../ValidationBlock";
import Guideline from "../Guideline";

import { createStyles } from "./styles";

var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var
    value =















    props.value,onChange = props.onChange,name = props.name,label = props.label,description = props.description,id = props.id,maxLength = props.maxLength,minLength = props.minLength,form = props.form,required = props.required,validationMessage = props.validationMessage,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass,placeholder = props.placeholder,_props$disabled = props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled,className = props.className,formGuidelines = props.formGuidelines;

  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.wrapper, className) },
    (label || description) && /*#__PURE__*/
    React.createElement("div", { className: classes.descriptionWrapper }, /*#__PURE__*/
    React.createElement("label", { htmlFor: name, className: clsx(classes.label) },
    label), /*#__PURE__*/

    React.createElement("p", { className: classes.description }, description)), /*#__PURE__*/


    React.createElement("div", { className: classes.fieldWrapper }, /*#__PURE__*/
    React.createElement("textarea", {
      value: value,
      onChange: onChange,
      name: name,
      id: id,
      maxLength: maxLength,
      minLength: minLength,
      required: required,
      form: form,
      placeholder: placeholder,
      disabled: disabled,
      ref: ref,
      className: clsx(
      classes.textArea,
      classes["textAreaValidation".concat(capitalize(validationPassed.toString()))],
      disabled && classes.textAreaDisabled) }), /*#__PURE__*/


    React.createElement(ValidationBlock, {
      value: value,
      validationMessage: validationMessage,
      validationPassed: validationPassed }),

    (formGuidelines === null || formGuidelines === void 0 ? void 0 : formGuidelines.guidelines) && /*#__PURE__*/
    React.createElement(Guideline, {
      text: formGuidelines.guidelines,
      showGuidelinesByDefault: formGuidelines.showGuidelinesByDefault,
      className: classes.textAreaGuideline }))));





});
TextArea.displayName = 'TextArea';

export default TextArea;
//# sourceMappingURL=index.js.map